import { PUT_BANNERS_START } from '../../types';

export const put_banners = (payload) => ({
  type: PUT_BANNERS_START,
  payload,
});
